// Chronik chapters read "one-pagey": the body fades in, and the next/previous
// chapter can be reached with the arrow keys as well as the buttons. Turbo Drive
// does the actual page swap, so this only handles intent and the entry animation.
let onKeyDown = null

export function chapterTargets(root = document) {
  const chapter = root.querySelector("[data-chapter]")
  if (!chapter) return null

  return {
    previous: chapter.dataset.previous || null,
    next: chapter.dataset.next || null
  }
}

export function startChapters(root = document) {
  stopChapters()
  const chapter = root.querySelector("[data-chapter]")
  if (!chapter) return { started: false }

  requestAnimationFrame(() => chapter.classList.add("is-open"))

  onKeyDown = (event) => {
    if (event.metaKey || event.ctrlKey || event.altKey) return
    const targets = chapterTargets(root)
    if (!targets) return

    const destination = event.key === "ArrowRight" ? targets.next : event.key === "ArrowLeft" ? targets.previous : null
    if (!destination) return

    event.preventDefault()
    visit(destination)
  }

  document.addEventListener("keydown", onKeyDown)
  return { started: true, stop: stopChapters }
}

export function stopChapters() {
  if (onKeyDown) document.removeEventListener("keydown", onKeyDown)
  onKeyDown = null
}

function visit(destination) {
  if (window.Turbo) {
    window.Turbo.visit(destination)
  } else {
    window.location.assign(destination)
  }
}
